import {
    metricLabelStyle,
    metricTileStyle,
    metricToneStyle,
    metricValueStyle,
    statusPillStyle,
} from "./bisLayoutStyles";
import { statusLabel } from "../shared/controleConstants";

export function MetricTile({ label, value, tone = "neutral" }) {
    const toneStyle = metricToneStyle(tone);
    return (
        <div style={{ ...metricTileStyle, borderColor: toneStyle.border, background: toneStyle.background }}>
            <span style={{ ...metricValueStyle, color: toneStyle.color }}>{value}</span>
            <span style={metricLabelStyle}>{label}</span>
        </div>
    );
}

export function StatusPill({ status }) {
    const finished = status === "TERMINE";
    return (
        <span style={statusPillStyle(finished)}>
            {statusLabel(status)}
        </span>
    );
}
